import getCMSDomain from "./getCMSDomain";
import getEnvironment from "./getEnvironment";

const buildSalesLiveUrl = (catalogueRef: string) => {
  const environment = getEnvironment();
  const buyerAPIDomain = getCMSDomain(environment);
  const url = new URL(`${buyerAPIDomain}sales/live`);
  url.searchParams.append("catalogueRef", catalogueRef);
  return url.href;
};

export default buildSalesLiveUrl;
